import { UPDATE_FAQ } from '../actions/types';
import shortid from 'shortid';
const initialState = {
  faqs: [],
  faq: {},
  requestFailed: false,
  requestFailedMessage: {},
  requestSuccessMessage: '',
  short_id: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_FAQ:
      if (
        (Object.keys(action.payload).length > 0 &&
          action.payload.errorMessage === '') ||
        action.payload.errorMessage === undefined
      ) {
        action.payload.processStatus = 'edit is succeeded';

        return {
          //...state,
          faq: action.payload,
          //add state data
          faqs: [],
          requestFailed: false,
          requestFailedMessage: { error: 'no' },
          requestSuccessMessage: action.payload.message,
          short_id: shortid.generate(),
          //
        };
      } else {
        return {
          //...state,
          faq: [],
          requestFailed: true,
          requestFailedMessage: action.payload,
          //add state data
          faqs: [],
          requestSuccessMessage: 'error in edit question',
          short_id: shortid.generate(),
          //
        };
      }
    default:
      return state;
  }
}
